import qs from 'qs';

export type BoltQueryString = {
  action?: string;
  braze_campaign_id?: string;
  braze_channel?: string;
  canvas_id?: string;
  canvas_step?: string;
  captcha?: boolean;
  client?: string;
  colour?: string;
  email?: string;
  fbclid?: string;
  fromRegistration?: string;
  from_nudge?: string;
  gclid?: string;
  gender?: 'womens' | 'mens';
  guest_id?: string;
  internal_source?: string;
  itemId?: string;
  lid?: string;
  medium?: string;
  message_variation_id?: string;
  msclkid?: string;
  notify?: string;
  productId?: string;
  q?: string;
  queryID?: string;
  raffle?: boolean;
  returnUrl?: string;
  size?: string;
  sort?: string;
  source?: string;
  token?: string;
  ttclid?: string;
  userId?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_medium?: string;
  utm_source?: string;
  utm_term?: string;
  wbraid?: string;
};

export function parseSearchString(search: string) {
  return qs.parse(search, { ignoreQueryPrefix: true }) as BoltQueryString;
}

export function parseRequest(request: Request) {
  return parseSearchString(new URL(request.url).search ?? '');
}

export function stringify(params: BoltQueryString) {
  return qs.stringify(params, { addQueryPrefix: true });
}

export default {
  parseRequest,
  parseSearchString,
  stringify
};
